module.exports = __webpack_public_path__ + "img/019.ef49ec13.png";